// First focusable element on every page. Jumps straight to <main>
// (id="main-content") so keyboard / screen-reader users don't have to
// tab past Navigation, search, locale switcher, etc. on every page
// load. Visually hidden until focused — see ``.skip-link`` in
// index.css.
//
// Pair with the matching landmark wrapper:
//   <SkipLink />
//   <Navigation ... />
//   <main id="main-content"> ... </main>

import { useT } from "../i18n/I18nContext";

export default function SkipLink() {
  const t = useT();
  return (
    <a href="#main-content" className="skip-link">
      {t("a11y.skip_to_main")}
    </a>
  );
}
